import rootReducer from "../store";
import { removeEmptyKeysFromState } from "./CommonUtils";
import { toast } from "react-toastify";
import {
  RenderPage,
  setCategoryDropdown,
  setMetaLoading,
  setPaginationTotalCount,
  setSidebarData,
  setTableLoading,
  setTableTabs,
  setUserInfo,
  setUserInformation,
  setVersion,
  setVersionDate,
  startDownloadLoading,
  updateRendererFormState,
} from "../slices/common/reducer";
import { setModuleAccessTree } from "../slices/moduleAccess/moduleAccessTree";
import { addSideBar } from "../slices/sidebar/sidebarSlice";
import { applyPendingMenus } from "../slices/sidebar/pendingMenus";
import {
  setAgEntityType,
  setAgOrgId,
  setAgsaEntityType,
  setAgsaOrgId,
  setDrodownData,
  setPspEntityType,
  setPspOrgId,
} from "../slices/header/headerSlice";
import api from "./interface";
import {
  setPspCategoryDropdown,
  setPspFieldJson,
} from "../slices/psp/serviceProvider/reducer";
import {
  setAgCategoryDropdown,
  setAgFieldJson,
} from "../slices/ag/affinityGroup/affinityGroupSlice";
import {
  setManualPaymentFieldJson,
  setManualPaymentModeDropdown,
  setProposalFieldsJSON,
} from "../slices/orders/orderSlice";

const entityStatusKeys = {
  BTXN: "biller_status",
  BUTX: "final_status",
  BREF: "ap_refund_txn_status",
  BCB: "status",
  PORD: "status",
  PTXN: "txn_status",
  PLST: "status",
  PLRF: "refund_txn_status",
  PMERC: "status",
  PRC: "status",
  UPTXN: "upi123pay_txn_status",
  UTXN: "txn_status",
  CBT: "transfer_status",
  CAMP: "campaign_status",
  LRM: "status",
  LCBT: "recon_status",
  BCT: "recon_status",
  USR: "status",
  ROL: "status",
  BRC: "status",
  PPGA: "status",
};

export const sidebarList = (organizationId) => {
  api
    .get(`/module/getRoleModuleAccessTreeMap`, {
      params: {
        // organizationType: organizationType, // Add organizationType to params
        orgId: organizationId,
      },
    })
    .then((res) => {
      // One module tree feeds both slices, so the sidebar and the action-level
      // access list can never disagree about which modules exist.
      const data = applyPendingMenus(res?.data);

      rootReducer.dispatch(addSideBar(data));

      const allMenus = Object.values(data || {}).flatMap(
        (entry) => entry.menus || []
      );
      rootReducer.dispatch(setSidebarData(allMenus));
    })
    .catch((err) => {
      console.log("error", err);
    });
};

export const getSwitchDropdown = () => {
  return api
    .get(`/agsp/getPopupDataForUser`)
    .then((res) => {
      rootReducer.dispatch(setDrodownData(res.data));
      rootReducer.dispatch(setAgsaOrgId(res.data.AGSA[0]?.organizationid));
      rootReducer.dispatch(setPspOrgId(res.data.PSP[0]?.organizationid));
      rootReducer.dispatch(setAgOrgId(res.data.AG[0]?.organizationid));
      rootReducer.dispatch(setAgsaEntityType(res.data.AGSA[0]?.entitytype));
      rootReducer.dispatch(setPspEntityType(res.data.PSP[0]?.entitytype));
      rootReducer.dispatch(setAgEntityType(res.data.AG[0]?.entitytype));
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      // console.log(first)
    });
};

export const getListing = (entityType, functionName) => {
  api
    .get(`/agsp/getEntityList`, {
      params: {
        entityType: entityType,
      },
    })
    .then((res) => {
      rootReducer.dispatch(functionName(res.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getListingByOrgId = (entityType, orgId, functionName) => {
  const setLoadingTimeout = setTimeout(() => {
    rootReducer.dispatch(setTableLoading(true));
  }, 5000);
  api
    .get(`/agsp/getByOrganizationId`, {
      params: {
        entityType: entityType,
        organizationId: orgId,
      },
    })
    .then((res) => {
      rootReducer.dispatch(functionName(res.data));
      localStorage.setItem("entity_id", res.data[0].entityid);
      // rootReducer.dispatch(RenderPage());
      clearTimeout(setLoadingTimeout);
    })
    .catch((err) => {
      console.log(err);
      clearTimeout(setLoadingTimeout);
      rootReducer.dispatch(setTableLoading(false));
    });
};

export const getData = (entity_id, entity_type) => {
  let fd = new FormData();

  fd.append("entityid", entity_id);
  fd.append("entitytype", entity_type);
  api
    .post(`/entity/read`, fd, {
      // headers: {
      //   "Content-Type": "multipart/form-data",
      // },
    })
    .then((res) => {
      console.log(res.data);
      rootReducer.dispatch(updateRendererFormState(res.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

let debounceTimeout;
const debounce = (func, delay) => {
  return function (...arg) {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => func.apply(this, arg), delay);
  };
};

export const getFilteredDataWithTabs = debounce(
  (
    entityType,
    functionName,
    data,
    params,
    activeTab,
    parentId,
    organizationId,
    ownerId,
    enterpriseId,
    userId,
    organizationType,
    organizationIdUser,
    parentId2,
    parentType,
    orgType,
    agId,
    statusCheck
  ) => {
    const setLoadingTimeout = setTimeout(() => {
      rootReducer.dispatch(setTableLoading(true));
    }, 300);

    let updatedParams = { ...params };
    let updatedData = { ...data };
    removeEmptyKeysFromState(updatedData);

    const matchedStatusKey = entityStatusKeys[entityType];
    if (activeTab !== "ALL") {
      // updatedData = { ...updatedData, [matchedStatusKey]: activeTab };

      updatedParams = {
        ...updatedParams,
        tab_column: matchedStatusKey,
        tab_value: activeTab,
      };
    }

    if (parentId) {
      updatedData.parent_id = parentId;
    }

    if (parentId2) {
      updatedData.parentId = parentId2;
    }

    if (parentType) {
      updatedData.parentType = parentType;
    }

    if (organizationId) {
      updatedData.organizationid = organizationId;
    }
    if (agId) {
      updatedData.ag_id = agId;
    }
    if (statusCheck) {
      updatedData.status = statusCheck;
    }

    if (organizationIdUser) {
      updatedData.org_id = organizationIdUser;
    }

    if (ownerId) {
      updatedData.owner_id = ownerId;
    }

    if (enterpriseId) {
      updatedData.enterpriseid = enterpriseId;
    }
    if (enterpriseId) {
      updatedData.enterpriseid = enterpriseId;
    }
    if (userId) {
      updatedData.user_id = userId;
    }
    if (organizationType) {
      updatedData.organization_type = organizationType;
    }

    if (orgType) {
      updatedData.orgType = orgType;
    }

    if (!updatedParams?.sort_column) delete updatedParams?.sort_order;
    if (updatedData?.parentId || updatedData?.parentType) {
      updatedParams = {
        ...updatedParams,
        parentId: updatedData?.parentId,
        owner_id: updatedData?.owner_id,
        parentType: updatedData?.parentType,
        parent_type: updatedData?.parent_type,
        orgType: updatedData?.parent_type,
      };
    }

    delete updatedParams.from_date;
    delete updatedParams.to_date;
    delete updatedParams?.column;
    delete updatedParams?.value;

    delete updatedData?.parentId;
    delete updatedData?.parentType;

    api
      .post(`/entity/getFilteredDataWithTabs/${entityType}`, updatedData, {
        params: updatedParams,
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        rootReducer.dispatch(functionName(res?.data.entity_list));
        rootReducer.dispatch(setTableTabs(res?.data.entity_tab));
        clearTimeout(setLoadingTimeout);
        rootReducer.dispatch(setTableLoading(false));
      })
      .catch(() => {
        clearTimeout(setLoadingTimeout);
        rootReducer.dispatch(setTableLoading(false));
      });
  },
  1000
);

export const getVersion = async () => {
  try {
    const response = await api.get("/dev/version");
    rootReducer.dispatch(setVersion(response.data.version));
    rootReducer.dispatch(setVersionDate(response.data.version_date));
  } catch (error) {
    console.log("Error in getting version", error);
  }
};

export const getCategoryDropdown = async (
  entityType,
  columnName,
  fieldJson
) => {
  let fd = new FormData();
  let response = [];
  if (entityType === "PSP" && columnName === "psp_category") {
    fd.append("entityType", entityType);
    fd.append("columnName", columnName);

    response = await api.post(`/entity/getDropdownData`, fd);
    rootReducer.dispatch(setCategoryDropdown(response.data));
    if (fieldJson) {
      const customValues = Array.isArray(response?.data)
        ? response.data.map((item) => ({
            label: item,
            value: item,
          }))
        : [];
      rootReducer.dispatch(setPspCategoryDropdown(customValues));
      const updatePspFieldJson = {
        ...fieldJson,
        "1717412308306-customSelect": {
          ...fieldJson["1717412308306-customSelect"],
          "data-customvalue": customValues,
        },
      };
      rootReducer.dispatch(setPspFieldJson(updatePspFieldJson));
    }
  } else if (entityType === "AGRP" && columnName === "ag_category") {
    fd.append("entityType", entityType);
    fd.append("columnName", columnName);

    response = await api.post(`/entity/getDropdownData`, fd);
    rootReducer.dispatch(setCategoryDropdown(response.data));
    if (fieldJson) {
      const customValues = Array.isArray(response?.data)
        ? response.data.map((item) => ({
            label: item,
            value: item,
          }))
        : [];
      rootReducer.dispatch(setAgCategoryDropdown(customValues));
      const updatePspFieldJson = {
        ...fieldJson,
        "1717412308306-customSelect": {
          ...fieldJson["1717412308306-customSelect"],
          "data-customvalue": customValues,
        },
      };
      rootReducer.dispatch(setAgFieldJson(updatePspFieldJson));
    }
  } else if (entityType === "PMT" && columnName === "mode") {
    fd.append("entityType", entityType);
    fd.append("columnName", columnName);

    response = await api.post(`/entity/getDropdownData`, fd);

    rootReducer.dispatch(setCategoryDropdown(response.data));
    if (fieldJson) {
      const customValues = Array.isArray(response?.data)
        ? response.data.map((item) => ({
            label: item,
            value: item,
          }))
        : [];
      rootReducer.dispatch(setManualPaymentModeDropdown(customValues));
      const updateManualFieldJson = {
        ...fieldJson,
        "1717412315194-customSelect": {
          ...fieldJson["1717412315194-customSelect"],
          "data-customvalue": customValues,
        },
      };

      rootReducer.dispatch(setManualPaymentFieldJson(updateManualFieldJson));
    }
  }

  return response.data;
};

export const getAllDropdownListItems = async (
  type,
  proposalFieldsJSON,
  parentType,
  parentId,
  ownerType,
  ownerValue
) => {
  const fd = new FormData();

  fd.append("type", type);
  fd.append("parentType", parentType);
  fd.append("parentId", parentId);

  if (type === "CTY") {
    fd.append("ownerType", ownerType);
    fd.append("ownerValue", ownerValue);
  }

  try {
    const response = await api.post(
      `agsp/customer/getAllDropdownListItems`,
      fd
    );

    if (response.data) {
      const data = response.data;

      if (proposalFieldsJSON && Object.keys(proposalFieldsJSON).length) {
        const updatedProposalFieldsJSON = { ...proposalFieldsJSON };
        // Update `data-customvalue` based on `data-datasourcelist`
        Object.keys(updatedProposalFieldsJSON).forEach((key) => {
          const field = updatedProposalFieldsJSON[key];
          if (field["data-datasourcelist"] === type) {
            updatedProposalFieldsJSON[key] = {
              ...field,
              "data-customvalue": data,
            };
          }
        });
        rootReducer.dispatch(setProposalFieldsJSON(updatedProposalFieldsJSON));
      } else {
        console.warn(
          "proposalFieldsJSON is empty or undefined:",
          proposalFieldsJSON
        );
      }
      return data;
    } else {
      console.warn("error", response.data);
    }
  } catch (error) {
    console.error("Error fetching data", error);
  }
};

export const getUserInfo = async () => {
  return api
    .get(`/product/getUserInfo`)
    .then((res) => {
      rootReducer.dispatch(setUserInfo(res.data));
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      // console.log(first)
    });
};

export const downloadDocument = async (
  media_id,
  file_name = "downloaded-file"
) => {
  try {
    const res = await api.get(`/media/download/${media_id}`, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
      },
    });

    // Check if the Content-Type header is available in the response
    const contentType = res.headers["content-type"];

    // Set MIME type accordingly
    let mimeType = "application/octet-stream"; // Default type
    if (contentType) {
      mimeType = contentType; // Use the actual Content-Type from the response
    }

    const blob = new Blob([res.data], { type: mimeType });
    const url = window.URL.createObjectURL(blob);

    var a = document.createElement("a");
    a.href = url;
    a.download = file_name;
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error(error);
    // showToast(error.response?.data?.error_message, "error");
  }
};
